import React, { useState } from 'react'
import { DebouncedFunc } from 'lodash'

import { CategorySVG } from '@src/components/SVGS/CategorySVG'

import {
  CategoryIconButton,
  Divider,
  MobileCategoryCircle,
  StyledCross,
  StyledIconButton,
  StyledSearchBarIcon,
  StyledSearchInput,
} from './SearchHeadStyles'
import { useBottomSheetStack } from '../../../hooks/useBottomSheetStack/useBottomSheetStack'

export const SearchHeadMobile: React.FC<{
  showSearchBar: boolean
  startAnimation: boolean
  placeholder: string
  startClosingAnimation: () => void
  executeSearch: DebouncedFunc<(searchTerm: string) => void>
  closeSearchResults: () => void
  searchTerm: string
  setSearchTerm: (searchTerm: string) => void
  isMenuView?: boolean
  isStackedMenu?: boolean
  showCategories?: boolean
  inputRef?: React.RefObject<HTMLInputElement>
  isSearchFocused?: boolean
  setIsSearchFocused?: (isFocused: boolean) => void
}> = ({
  showSearchBar,
  startAnimation,
  placeholder,
  startClosingAnimation,
  executeSearch,
  closeSearchResults,
  searchTerm,
  setSearchTerm,
  isMenuView = false,
  isStackedMenu = false,
  showCategories = false,
  inputRef,
  isSearchFocused: externalIsSearchFocused,
  setIsSearchFocused: externalSetIsSearchFocused,
}) => {
  const [internalIsFocused, setInternalIsFocused] = useState(false)
  const isFocused = externalIsSearchFocused ?? internalIsFocused
  const setIsFocused = externalSetIsSearchFocused ?? setInternalIsFocused
  const { categoriesBottomSheetController } = useBottomSheetStack()

  const updateSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm)
    if (searchTerm.length < 3) {
      closeSearchResults()
      executeSearch.cancel()
    } else {
      executeSearch(searchTerm)
    }
  }

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isStackedMenu) startClosingAnimation() // Always open in stacked menu
    setIsFocused(false)
    e.currentTarget.blur()
  }

  return (
    <>
      <StyledSearchInput
        ref={inputRef}
        $showSearchBar={isStackedMenu || showSearchBar}
        $startAnimation={startAnimation}
        $isMenuView={isMenuView}
        $isStackedMenu={isStackedMenu}
        onChange={e => {
          updateSearch(e.target.value)
          if (!e.target.value && isMenuView) handleBlur(e)
        }}
        onFocus={e => {
          setIsFocused(true)
          updateSearch(e.target.value)
        }}
        onBlur={() => setIsFocused(false)}
        value={searchTerm}
        placeholder={placeholder}
      />
      <StyledSearchBarIcon
        $showSearchBar={isStackedMenu || showSearchBar}
        $startAnimation={startAnimation}
        $isFocused={isFocused}
        id="search"
        $isMenuView={isMenuView}
      />
      <StyledIconButton
        onClick={() => {
          updateSearch('')
          if (!isStackedMenu) startClosingAnimation()
        }}
        $display={isStackedMenu || showSearchBar}
        $startAnimation={startAnimation}
        $isMenuView={isMenuView}
      >
        <StyledCross id="styled-cross" title="Close Search" />
      </StyledIconButton>
      {showCategories && (
        <div>
          <MobileCategoryCircle $showSearchBar={showSearchBar}>
            <CategoryIconButton
              $showSearchBar={showSearchBar}
              $startAnimation={startAnimation}
              onClick={() => categoriesBottomSheetController.open()}
            >
              <CategorySVG id="category" />
            </CategoryIconButton>
          </MobileCategoryCircle>
          {showSearchBar && (
            <CategoryIconButton
              $showSearchBar={showSearchBar}
              $startAnimation={startAnimation}
              onClick={() => categoriesBottomSheetController.open()}
            >
              <Divider />
              <CategorySVG id="category" />
            </CategoryIconButton>
          )}
        </div>
      )}
    </>
  )
}
